import { NETWORK_CALL_FAILED, IApiConfig } from "@hopper-b2b/types";
import {
  airBookingApi,
  PassengersForFareRequest,
  PassengersResponse,
} from "@b2bportal/air-booking-api";
import { axiosInstance } from "../AxiosInterceptor";
import { trackEvent } from "../tracking/trackEvent";

export const validateUserPassengers = (
  req: PassengersForFareRequest,
  apiConfig?: IApiConfig
): Promise<PassengersResponse> =>
  new Promise((resolve, reject) => {
    airBookingApi(axiosInstance)
      .apiV0PassengerValidationPost(req)
      .then((res) => {
        const responseBody = res.data as PassengersResponse;
        resolve(responseBody);
      })
      .catch((e) => {
        trackEvent(
          {
            eventName: NETWORK_CALL_FAILED,
            properties: {
              url: window.location.pathname,
            },
          },
          apiConfig
        );
        reject(e);
      });
  });
